import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { mergeMap, Observable, tap } from "rxjs";
import { environment } from "src/environments/environment";
import { ConfigVaultService, Token } from "./config-vault.service";

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {

    private readonly _env: string;
    private readonly _app: string;

    constructor(
        private injector: Injector,
        private readonly configVaultService: ConfigVaultService
    ) {
        this._env = environment.environment.toUpperCase();
        this._app = environment.jwtConfig.appName;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only apply to gateway API URLs
        if (request.url.indexOf('api.rwbaird.com') == -1) {
            return next.handle(request);
        }

        const token = this.getTokenFromCache(this._app, this._env);

        if (token != null) {
            const clonedRequest = request.clone({ setHeaders: { Authorization: `Bearer ${token.AccessToken}` } });
            return next.handle(clonedRequest);
        }

        return this.configVaultService.getAccessToken()
            .pipe(
                tap(token => this.storeTokenInCache(this._app, this._env, token))
            )
            .pipe(
                mergeMap(token => {
                    var clonedRequest = request.clone({ setHeaders: { Authorization: `Bearer ${token.AccessToken}` } });
                    return next.handle(clonedRequest);
                })
            );
    }

    private getTokenFromCache(appName: string, environment: string): Token | undefined {
        const json = sessionStorage.getItem(this.getTokenCacheKey(appName, environment));
        if (json) {
            const token = <Token>JSON.parse(json);
            const now = new Date();
            const expires = new Date(token.ExpiresOn);

            if (expires > now) {
                return token;
            }
            else {
                console.log(`configvault.service cached access token expired`);
            }
        }

        return undefined;
    }

    private storeTokenInCache(appName: string, environment: string, token: Token) {
        const json = JSON.stringify(token);
        sessionStorage.setItem(this.getTokenCacheKey(appName, environment), json);
    }

    private getTokenCacheKey(appName: string, environment: string): string {
        return `${environment}-${appName}-AccessToken`;
    }
}